module.exports = __webpack_public_path__ + "static/media/screenshot_phone-ar.7f6f74c5.png";